<template>
  <div>
    <div class="banner">
      <img :src="imgScr" alt=" ">
    </div>
    <div class="signIn">
      <h2 v-if="wall">{{wall.title}}</h2>
      <div class="userImg"><img :src="userImg"></div>
      <p>{{text}}</p>
      <div class="sign" v-if="wall">
        <input v-show="wall.name != 0" maxlength="6" v-model="name" type="text" placeholder="姓名">
        <input v-show="wall.mobile != 0" maxlength="11" v-model="mobile" type="tel" placeholder="电话">
        <input v-show="wall.mail != 0" maxlength="30" v-model="mail" type="email" placeholder="邮箱">
        <input v-show="wall.other1" v-model="other1" type="text" :placeholder="wall.other1">
        <input v-show="wall.other2" v-model="other2" type="text" :placeholder="wall.other2">
        <input v-show="wall.other3" v-model="other3" type="text" :placeholder="wall.other3">
        <a class="buttom" @click="signIn">签到</a>
      </div>

      <div class="sign" v-else><a class="buttom" @click="liveing">进入直播间</a></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import tool,{app_Id} from '../../kits/Tools.js';
import { Toast } from 'vant';
import { Field } from 'vant';
import { Button } from 'vant';
Vue.use(Button);
Vue.use(Field);

export default {
    data() {
        return {
          imgScr: "",
          fans_id:"",
          ds_id:'',
          wall:'',
          wallId:'',
          name:'',
          mobile:'',
          mail:'',
          other1:'',
          other2:'',
          other3:'',
          text:'留下您的信息，让我们记住您！',
          userImg:'https://tengfaceliveuser.tengface.net/web/common/logo.png',
          isCache:false,
          dynamicData:null,
          share:{
            title:'评论上墙签到',
            desc:'签到后可在现场大屏幕上看到您的评论',
            link:location.href,
            image:'https://tengfaceliveuser.tengface.net/web/common/logo.png'
          }
        }
    },
    mounted() {
      this.ds_id =  tool.getQueryDsId();
      this.imgScr = tool.baseUrl1()+"/wap/index/dsImg/?ds_id=" + this.ds_id;
      tool.login(app_Id,this.personDataInit);
    },
    methods: {
      loadAll(data){
        var that = this;
        this.wall = data.wall_sign_conf;
        if(this.wall == null){
          this.text = '签到功能未开启！';
          return false;
        }
        this.wallId = this.wall.wall_id;
        this.share.title = this.wall.title;
        this.share.desc = data.direct_seeding.desc;
        this.checkSign();
        this.weixinShare();
      },
      personDataInit(fans) {
        //重缓存中获取数据
        this.fans_id = fans.fans_id;
        this.userImg = fans.header;
        tool.getDsInfo(this.loadAll);
        console.log(this.userImg)
      },
      checkSign(){
        var that = this;
        var url = tool.baseUrl2() + '/wall/is_sign';
        var option = 'wall_id='+this.wallId + '&fans_id='+this.fans_id;
        this.axios.post(url,option).then(function(data){
          var data = data.data;
          if(data.code == 200){
            Toast(data.data);
            setTimeout(function(){
              that.$router.push({'path':'/home'})
            },2000)
          }else{
            console.log(data);
          }
        }).catch(function(data){

        })
      },
      signIn(){
        var that = this;
        var url = tool.baseUrl2() + '/wall/sence_sign';
        var option = 'is_sence=1'+'&ds_id='+this.ds_id+'&fans_id='+this.fans_id+'&name='+this.name+'&mail='+this.mail;
        option += '&mobile='+this.mobile+'&other1='+this.other1+'&other2='+this.other2+'&other3='+this.other3;
        if(this.wall.name != '0' && !this.name){
          Toast('姓名不能为空');
          return false;
        }
        if(this.wall.mobile != '0' && !this.mobile){
          Toast('电话不能为空');
          return false;
        }
        if(this.wall.mobile != '0' && !/^[1][3,4,5,7,8][0-9]{9}$/.test(this.mobile)){
          Toast('请填写正确的手机号码');
          return false
        }
        if(this.wall.mail != '0' && !/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(this.mail)){
          Toast('请填写正确的邮箱地址');
          return false
        }
        Toast.loading({
          mask: true,
          message: '签到中...'
        });
        this.axios.post(url,option).then(function(data){
          var data = data.data;
          if(data.code == 200){
            Toast('签到成功！');
            setTimeout(function(){
              that.$router.push({'path':'/home'})
            },1000)
          }else{
            Toast(data.data);
          }
        }).catch(function(data){

        })
      },
      weixinShare(){
          var that = this;
          var url = 'http://plive.shikee.tv/fans/share/getWxParams';
          var option = 'no_dsid=1';
          this.axios.post(url,option).then(function(res){
              var data = res.data;
              if(data.code == 200){
                  wx.config({
                      appId: data.data.params.appid, // 必填
                      timestamp: data.data.params.timestamp, // 必填，生成签名的时间戳
                      nonceStr: data.data.params.noncestr, // 必填，生成签名的随机串
                      signature: data.data.params.signature, // 必填，签名，见附录1
                      jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                  });

                  wx.ready(function() {
                      //微信好友分享
                      wx.onMenuShareAppMessage({
                          title: that.share.title, // 分享标题
                          desc: that.share.desc, // 分享描述
                          link: that.share.url, // 分享链接，该链接域名必须与当前企业的可信域名一致
                          imgUrl: that.share.image, // 分享图标
                          type: '', // 分享类型,music、video或link，不填默认为link
                          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                          success: function() {
                              
                          },
                          cancel: function() {
                              console.log("用户取消分享后执行的回调函数");
                          }
                      });

                      //微信朋友圈分享
                      wx.onMenuShareTimeline({
                          title: that.share.title, // 分享标题
                          link: that.share.url, // 分享链接，该链接域名必须与当前企业的可信域名一致
                          imgUrl: that.share.image, // 分享图标
                          success: function() {
                              
                          },
                          cancel: function() {
                              console.log("用户取消分享后执行的回调函数");
                          }
                      });
                  });
              }else{
                  console.log(data);
              }
          }).catch(function(res){
              console.log(res.data)
          })
      },
      liveing(){
        this.$router.push({'path':'/home'});
      }
    }
}
</script>

<style scoped>
.banner {
  height: 100%;
  width: 100%;
  text-align: center;
  position: absolute;
  z-index: -1;
  background: #000;
  overflow: hidden;
}

.banner img {
  height: 100%;
  width: 100%;
  display: block;
  opacity: 0.5;
}

.signIn {
  width: 100%;
  max-height: 100%;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  overflow-y: scroll;
  padding: 40px 0;
  box-sizing: border-box;
}

.logo {
  margin: 10px auto;
  max-width: 80%;
}

h2 {
  font-size: 24px;
  color: #fff;
  text-shadow: 0 4px 10px #333;
  width: 80%;
  margin: 0 auto;
}

.userImg {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 2px solid #ebbf61;
  overflow: hidden;
  margin: 24px auto;
}

.userImg img {
  width: 100%;
}

p {
  color: #ebbf61;
}

.sign {
  width: 80%;
  margin: 10px auto;
  line-height: 40px;
  color: #fff;
}

.sign input {
  width: 100%;
  height: 40px;
  display: block;
  border: 1px solid #fff;
  padding: 0 5px;
  background: rgba(255,255,255,0.17);
  box-sizing: border-box;
  margin-bottom: 16px;
  border-radius: 5px;
  color: #fff;
}

input::placeholder {
  color: rgba(255,255,255,0.5);
}

.buttom {
  width: 100%;
  height: 40px;
  display: block;
  background: linear-gradient(#ebbf61, #d8ad4f);
  font-size: 22px;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// signIn.vue?a6d9bad8